var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('div',{staticClass:"jin-m-base"},[(_vm.info.user_name)?_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.info.user_name)+" | "+_vm._s(_vm.info.age)+"岁")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }